let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cIBeW")).then(() => parcelRequire('57oKS'));